import JSX from "../../helpers/react.js";
import {favoriteTypes} from "../../config.js";
import RefObject = JSX.RefObject;
import {askQuestion, createElementFromHTML, showAskDialog, showNotice} from "../../helpers/functions.js";
import {ServerApi} from "../../api.js";

export function CheckBox({favType, OnSelect}: {favType: { title: string; icon: string; id: number;}, OnSelect: (id: number, selected: boolean)=>any }){
    const inputRef : RefObject<HTMLInputElement>= {};
    const li: RefObject = {};
    return (
        <li onClick={toggleCheckBox} className="bordered-fa" data-listid={favType.id} ref={li}>
            <input type="checkbox" className="bordered hidden" ref={inputRef}/>
            <i className={["fa", favType.icon]} /> {favType.title}
        </li>
    )
    function toggleCheckBox(){
        inputRef.value!.checked = !inputRef.value!.checked
        const value = inputRef.value!.checked;
        if(value) li.value!.classList.add("active")
        else li.value!.classList.remove("active");
        OnSelect(favType.id, value)
    }
}
export default function ClearFav(){
    const btn: RefObject<HTMLButtonElement> = {};
    const selected = new Set<number>();
    return (
        <div id="clear-fav" className="tab-content" style={{margin: '0 10px'}}>
            <br />
            <h4>Очистка списков.</h4>
            <div style={{display: 'inline-flex', alignItems: 'center'}}>
                <span>Очистить из: </span>
                <ul style={{marginLeft: '15px'}} className="horizontal-ul">
                    {
                        ...favoriteTypes.map(type=> <CheckBox favType={type} OnSelect={OnSelect}/>)
                    }
                </ul>
            </div>
            <div style="text-align: center">
                <button className="main-button bordered blocked" style="margin: 15px" ref={btn} onClick={doIT}>Очистить</button>
            </div>
        </div>
    );


    function OnSelect(id: number, value: boolean){
        if(value) selected.add(id)
        else selected.delete(id);
        if(selected.size)
            btn.value!.classList.remove('blocked')
        else btn.value!.classList.add('blocked');
    }
    async function doIT(){
        if(!selected.size) return;
        if(
            await showAskDialog("Очистить списки?",
                <div>
                    Вы уверены, что хотите удалить аниме из следующих списков: {
                    createElementFromHTML(
                            Array.from(selected)
                                .map(id=>`<b>${favoriteTypes.find(e=>e.id===id)!.title}</b>`)
                                .join(', ')
                        )
                    }?
                    <br/>
                    <b>Обратите внимание!</b> <br />
                    Это действие отменить нельзя! Прежде чем чистить списки, убедитесь, что Вы сделали их бэкап.
                </div>,
                'Удалить'
            )
        )
            await deleteLists(...selected);

    }
}
async function deleteLists(...listIds: number[]){
    if(listIds.length === favoriteTypes.length)
        await ServerApi.users.removeLists(user_id!);
    else await Promise.all(
        listIds.map(id=>ServerApi.users.removeLists(user_id!, id))
    );
    showNotice("Успех", "Списки успешно очищены.");
    await new Promise(r=>setTimeout(r, 1500));
    window.location.reload();
}